import { AlertTriangle, BarChart3, Boxes, CalendarDays, ClipboardCheck, ClipboardList, LucideIcon, Receipt, Trash2 } from 'lucide-react';
import { AnalysisReportType } from '../../../../services/analysis/analysisReportsService';

/** Which picker the slide-over shows. Mirrors spec-6's "Report types offered" table. */
export type ReportPickerKind = 'week' | 'month' | 'inventoryCount' | 'inventoryPair';

export interface ReportTypeOption {
  type: AnalysisReportType;
  picker: ReportPickerKind;
  icon: LucideIcon;
}

export const REPORT_TYPE_OPTIONS: ReportTypeOption[] = [
  { type: 'revenue', picker: 'week', icon: Receipt },
  { type: 'weekly', picker: 'week', icon: BarChart3 },
  { type: 'monthly', picker: 'month', icon: CalendarDays },
  { type: 'waste', picker: 'month', icon: Trash2 },
  { type: 'priceAlerts', picker: 'week', icon: AlertTriangle },
  { type: 'inventoryLeakage', picker: 'inventoryPair', icon: Boxes },
  { type: 'inventoryOrder', picker: 'inventoryCount', icon: ClipboardList },
  { type: 'inventoryManagement', picker: 'inventoryCount', icon: ClipboardCheck },
];
